@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/color-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/apex-chart.scss';

:host {
  background-color: var(--white-layout-302-level-1-elevation);
  color: var(--main-titles-inputs-600);
  padding-top: calc(var(--spacer) * 1.5);
  padding-bottom: calc(var(--spacer) * 1.5);
}

.wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  &.is-loading {
    .access-data-protection-chart {
      opacity: 0;
    }

    .content {
      height: 200px;
    }
  }

  &:not(.is-error):not(.is-empty):not(.is-loading) {
    .apexcharts-xaxis-label {
      &.has-action {
        cursor: pointer;

        &:hover {
          fill: var(--blue-layout-301-active);
        }

        &:focus {
          fill: var(--blue-layout-500-focus);
        }

        &:active {
          fill: var(--blue-layout-301-active);
        }
      }
    }
  }
}

.content {
  width: 100%;
  height: 216px;
  overflow-y: hidden;
}

.widget-loading {
  bottom: calc(var(--spacer) * 1.5);
}

.apexcharts-grid-borders {
  line {
    stroke: var(--chart-101-pressed-dividers);
  }
}

.apexcharts-gridline {
  stroke: var(--chart-101-pressed-dividers);
}

.access-data-protection-chart {
  margin-left: -20px;
  transform: translateY(10px);

  .apexcharts-tooltip {
    border: 1px solid var(--chart-101-pressed-dividers);
    background: var(--white-layout-303-level-2-elevation);

    .tooltip {
      background-color: var(--white-layout-303-level-2-elevation);
      color: var(--main-titles-inputs-600);
      padding: calc(3 * var(--spacer));
      font-size: var(--body-size);
      width: 130px;
      white-space: normal;

      &--value {
        font-weight: bold;
      }
    }
  }
}

.apexcharts-xaxis-label,
.apexcharts-yaxis-label {
  font-size: var(--body-size-xsmall);
  line-height: 1;
}

.apexcharts-yaxis-texts-g .apexcharts-yaxis-label tspan {
  font-family: var(--font-family-secondary-mono);
  font-size: var(--body-size-small);
}

.apexcharts-datalabels {
  .apexcharts-datalabel {
    fill: var(--body-text-arrows-400);
    font-family: var(--font-family-secondary-mono) !important;
  }
}

.apexcharts {
  &-yaxis {
    text {
      fill: var(--main-titles-inputs-600);
    }
  }
  &-xaxis {
    text {
      fill: var(--body-text-arrows-400);
    }
  }
}

.apexcharts-text tspan {
  font-family: var(--font-family-secondary);
  font-size: var(--body-size);
}

@media screen and (max-width: 1600px) {
  .access-data-protection-chart {
    transform: translateY(-10px);
  }
}

:host([data-display-mode='pdf']) {
  .wrapper {
    .content {
      .access-data-protection-chart {
        .apexcharts-canvas {
          margin-top: calc(var(--spacer) * 3);
          .apexcharts-grid {
            .apexcharts-gridlines-vertical + line,
            .apexcharts-gridlines-vertical + line + line {
              display: none;
            }
          }
          .apexcharts-xaxis {
            .apexcharts-xaxis-texts-g + line {
              display: none;
            }
          }
        }
        .apexcharts-xaxis-label,
        .apexcharts-yaxis-label {
          font-size: calc(var(--body-size-xsmall) + 2px);
          font-family: var(--font-family-secondary) !important;
        }
      }
    }
  }
}
